import { observable, action } from 'mobx'
import http from '../../services/httpServiceHealthCare'

const apiEndpoint = '/Submissions/get-submissions'
const summaryEndpoint = '/Submissions/summary'

class Submission {
  @observable info = {
    data: [],
    error: null,
  }

  @action fetchSubmissionSummary = async (startDate, endDate, surveyId) => {
    try {
      const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null
      const params = {}
      if (token) params.access_token = token
      if (startDate) params.startDate = startDate
      if (endDate) params.endDate = endDate
      if (surveyId) params.surveyId = surveyId
      const { data } = await http.get(summaryEndpoint, { params })
      return {
        surveySummaries: data?.surveySummaries ?? [],
        surveySummariesAllTime: data?.surveySummariesAllTime ?? [],
        monthlyAggregations: data?.monthlyAggregations ?? {},
        error: null,
      }
    } catch (error) {
      console.log(error)
      const status = error?.response?.status
      const message = error?.message || 'ไม่สามารถโหลดสรุปได้'
      return {
        surveySummaries: [],
        surveySummariesAllTime: [],
        monthlyAggregations: {},
        error: { status, message },
      }
    }
  }

  /** ดึงเฉพาะจำนวนฟอร์มรวมทุกปี (เบา ไม่ส่งช่วงวันที่) */
  @action fetchSubmissionSummaryTotals = async () => {
    try {
      const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null
      const params = { totalsOnly: true }
      if (token) params.access_token = token
      const { data } = await http.get(summaryEndpoint, { params })
      const list = data?.surveySummaries ?? data?.surveySummariesAllTime ?? []
      return { surveySummariesAllTime: Array.isArray(list) ? list : [], error: null }
    } catch (error) {
      console.log(error)
      return { surveySummariesAllTime: [], error: error?.message || null }
    }
  }

  @action fetchSubmissions = async (page = 1, limit = 20, startDate, endDate, surveyId) => {
    try {
      const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null
      const params = { page, limit }
      if (token) params.access_token = token
      if (startDate) params.startDate = startDate
      if (endDate) params.endDate = endDate
      if (surveyId) params.surveyId = surveyId
      const { data } = await http.get(apiEndpoint, { params })
      const list = data?.data ?? []
      const total = data?.pagination?.total ?? (Array.isArray(list) ? list.length : 0)
      return { data: Array.isArray(list) ? list : [], total, error: null }
    } catch (error) {
      console.log(error)
      const status = error?.response?.status
      const message = status === 504
        ? 'หมดเวลาการเชื่อมต่อ (504) — ข้อมูลอาจมีปริมาณมาก ลองโหลดใหม่หรือใช้ช่วงวันที่'
        : error?.message || 'ไม่สามารถโหลดข้อมูลได้'
      return { data: [], total: 0, error: { status, message } }
    }
  }
}

export default new Submission()
